import React, { FC, useMemo } from 'react';
import { DropzoneState } from 'react-dropzone';

import { Text } from '../../Text';
import { Box } from '../../Box';

import { TMediaUploaderPreviewMode } from '@src/atoms/MediaUploader/models';
import { IMediaImageResizeOption } from '@src/models/entity';
import { classnames } from '@src/utils/classnames';
import { Icon } from '@src/atoms/Icon';

import styled from './MediaUploaderDropPlace.module.scss';
import { MEDIA_UPLOADER_DROP_PLACE } from '../const';

interface IDropzoneDropPlaceProps {
  dropzone: DropzoneState;
  previewMode?: TMediaUploaderPreviewMode;
  previewSize?: IMediaImageResizeOption;
  isStretched?: boolean;
  isOuterContainerRef?: boolean;
  isDropPlaceGrey?: boolean;
}

const ICON_MODE_SIZE = {
  rectangle: 48,
  circle: 40,
};

export const MediaUploaderDropPlace: FC<IDropzoneDropPlaceProps> = ({
  dropzone,
  previewMode = 'rectangle',
  previewSize,
  isStretched,
  isOuterContainerRef,
  isDropPlaceGrey,
}) => {
  const isRounded = previewMode === 'circle' && !!previewSize;

  const wrapperClass = classnames(
    styled.root,
    isRounded && styled.rounded,
    isStretched && styled.dropZoneStreched,
    isOuterContainerRef ? styled.strechedInOuterContainer : styled.strechedDefault,
  );
  const iconSize = useMemo(() => {
    return ICON_MODE_SIZE[previewMode];
  }, [previewMode]);
  const sizeStyles = previewSize || {};

  return (
    <Box
      fullWidth
      className={wrapperClass}
      column
      data-elem={MEDIA_UPLOADER_DROP_PLACE}
      justifyContent={'center'}
      alignItems={'center'}
      padding={!isRounded ? 16 : undefined}
      {...dropzone.getRootProps()}
      style={isRounded ? sizeStyles : undefined}
      bgColor={isDropPlaceGrey ? 'basicGreyLight' : 'basicWhite'}
      borderColor="basicGreySemiDark"
    >
      <input {...dropzone.getInputProps()} data-testid="dropzone" />

      {isRounded && (
        <Box justifyContent={'center'}>
          <Icon name={'upload'} view={'basicGreySemiDark'} size={iconSize} />
        </Box>
      )}
      {!isRounded && (
        <Text id={'dropPlaceDescription'} color="basicGreySemiDark" size={'primary'}>
          {isStretched ? (
            'Перетяните сюда файлы, чтобы отправить их'
          ) : (
            <>
              Перетяните сюда файлы или{' '}
              <Text id="upload" tag={'span'} textDecoration={'underline'} color="basicGreySemiDark" size="primary">
                загрузите
              </Text>
            </>
          )}
        </Text>
      )}
    </Box>
  );
};
